import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import i18n from "@/plugins/i18n";
import "@/plugins/dayjs";
import "@/plugins/antd"; // TODO: Reduce bundle size: https://github.com/vueComponent/ant-design-vue/issues/325
import "@/plugins/tailwindcss";
import "@/plugins/loading-overlay";
import "@/plugins/recaptcha";
import "@/plugins/signaturepad";

import "@/directives";

import { INSIGHTS_KEY } from "@/constants/config";
import VueInsights from "@/plugins/insights";
// import authentication from "./services/authentication";

if (process.env.VUE_APP_TEST !== "e2e") {
  Vue.use(VueInsights, {
    iKey: INSIGHTS_KEY,
    router,
    appInsightsConfig: {
      autoTrackPageVisitTime: true
    }
  });
}

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === "production";

// If running inside Cypress...
if (process.env.VUE_APP_TEST === "e2e") {
  // Ensure tests fail when Vue emits an error.
  // @ts-expect-error Test Environment
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException; // Vue.config.errorHandler = (window as any).Cypress.cy.onUncaughtException;
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");

// authentication.initialize().then(() => {
//   new Vue({
//     router,
//     store,
//     i18n,
//     render: (h) => h(App)
//   }).$mount("#app");
// });

// If running e2e tests...
if (process.env.VUE_APP_TEST === "e2e") {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  // @ts-expect-error Test Environment
  window.__app__ = app; // (window as any).__app__ = App;
}
